// NOTE: also update sass/variables.sass
export const Breakpoints = {
  collapseSidebar: 1200,
  autoHideJobList: 1600,
  hideFeaturePreviewIllustration: 840,
}
